import MonedaSuggestionsStore from './MonedaSuggestionsStore';
import CodigoPostalSuggestionsStore from './CodigoPostalSuggestionsStore';
import UnidadDeMedidaSuggestionsStore from './UnidadDeMedidaSuggestionsStore';
import ProductoServicioSuggestionsStore from './ProductoServicioSuggestionsStore';
import SepomexCodigoPostalSuggestionsStore from './SepomexCodigoPostalSuggestionsStore';
import CartaPorteClaveUnidadPesoSuggestionsStore from './CartaPorteClaveUnidadPesoSuggestionsStore';
import CartaPorteProductoServicioSuggestionsStore from './CartaPorteProductoServicioSuggestionsStore';
import CartaPorteMaterialPeligrosoSuggestionsStore from './CartaPorteMaterialPeligrosoSuggestionsStore';
import CustomAddressComercioExteriorSuggestionsStore from './CustomAddressComercioExteriorSuggestionsStore';
import ComercioExteriorFraccionArancelariaSuggestionsStore from './ComercioExteriorFraccionArancelariaSuggestionsStore';

const CatalogoStore = {
  moneda: MonedaSuggestionsStore,
  codigo_postal: CodigoPostalSuggestionsStore,
  sepomex: SepomexCodigoPostalSuggestionsStore,
  unidad_de_medida: UnidadDeMedidaSuggestionsStore,
  producto_servicio: ProductoServicioSuggestionsStore,
  cartaporte_clave_unidad_peso: CartaPorteClaveUnidadPesoSuggestionsStore,
  cartaporte_producto_servicio: CartaPorteProductoServicioSuggestionsStore,
  cartaporte_material_peligroso: CartaPorteMaterialPeligrosoSuggestionsStore,
  custom_address_comercio_exterior: CustomAddressComercioExteriorSuggestionsStore,
  comercioexterior_fraccion_arancelaria: ComercioExteriorFraccionArancelariaSuggestionsStore,
};

export default CatalogoStore;
